export const INITIAL_BLOGS = [
  {
    id: 'blog-sabir-multani-legacy',
    slug: 'hakim-inqilab-sabir-multani-introduction-legacy',
    title: 'حکیم انقلاب دوست محمد صابر ملتانیؒ: حیات، خدمات اور قانون مفرد اعضاء کا سائنسی نظریہ',
    titleUrdu: 'حکیم انقلاب دوست محمد صابر ملتانیؒ: حیات، خدمات اور قانون مفرد اعضاء کا سائنسی نظریہ',
    titleEn: 'Hakim Inqilab Dost Muhammad Sabir Multani: Life, Legacy & Science of Qanoon Mufrad Aza',
    category: 'theory',
    categoryUrdu: 'قانون مفرد اعضاء',
    coverImage: 'https://images.unsplash.com/photo-1456513080510-7bf3a84b82f8?w=1200&auto=format&fit=crop&q=80',
    featuredImage: 'https://images.unsplash.com/photo-1456513080510-7bf3a84b82f8?w=1200&auto=format&fit=crop&q=80',
    author: 'حکیم مولانا سید عبدالوہاب شاہ شیرازی',
    authorTitle: 'فاضل طب والجراحت (FTJ) - ماہر قانون مفرد اعضاء',
    publishedDate: '2026-09-12',
    readTime: '9 منٹ',
    viewsCount: 780,
    status: 'published',
    linkedProductId: 'prod-2',
    excerpt: 'مجددِ طب حکیم انقلاب دوست محمد صابر ملتانیؒ کا جامع تعارف، سائنسی جدوجہد، طبِ یونانی کی تجدید، اعضاء رئیسہ و بافتوں (Tissues) کی روشنی میں قانون مفرد اعضاء کی تخلیق اور نظریہ تحریک، تسکین و تحلیل کی مکمل تفصیل۔',
    excerptUrdu: 'مجددِ طب حکیم انقلاب دوست محمد صابر ملتانیؒ کا جامع تعارف، سائنسی جدوجہد، طبِ یونانی کی تجدید، اعضاء رئیسہ و بافتوں (Tissues) کی روشنی میں قانون مفرد اعضاء کی تخلیق اور نظریہ تحریک، تسکین و تحلیل کی مکمل تفصیل۔',
    excerptEn: 'Detailed monograph on the life, medical revolution, and biological principles of Hakim Dost Muhammad Sabir Multani (R.A.), the father of Tibb-e-Pakistani.',
    tags: ['صابر ملتانی', 'قانون مفرد اعضاء', 'حکیم انقلاب', 'طب پاکستانی', 'تجدید طب', 'نبض شناسی', 'اعضاء رئیسہ'],
    seoTitle: 'حکیم انقلاب دوست محمد صابر ملتانیؒ: تعارف اور نظریہ قانون مفرد اعضاء',
    seoDescription: 'حکیم انقلاب صابر ملتانیؒ کی حیات، خدمات اور قانون مفرد اعضاء کے سائنسی اصول۔ تحریک، تسکین، تحلیل اور نبض شناسی پر جامع تحقیقی مضمون۔',
    seoKeywords: 'صابر ملتانی, sabir multani, قانون مفرد اعضاء, طب پاکستانی, مجدد طب, حکیم صابر ملتانی سوانح',
    content: `
      <p class="lead text-lg font-medium text-gray-800 leading-relaxed mb-4">
        برصغیر پاک و ہند کی طبی تاریخ میں <strong>حکیم انقلاب دوست محمد صابر ملتانی رحمہ اللہ</strong> وہ عبقری اور انقلابی شخصیت ہیں جنہوں نے روایتی طب کو محض تجرباتی اور فرسودہ نسخہ جات کی قید سے نکال کر جدید فزیالوجی (Physiology) اور اناٹومی (Anatomy) کی ٹھوس سائنسی بنیادوں پر استوار کیا۔ آپ کا پیش کردہ <strong>"قانون مفرد اعضاء" (Tibb-e-Pakistani)</strong> علمِ طب کی تاریخ میں ایک لازوال سائنسی کارنامہ ہے۔
      </p>

      <div class="my-6 p-5 rounded-2xl bg-emerald-50 border-r-4 border-emerald-700 text-emerald-950">
        <h3 class="text-base font-bold text-emerald-900 mb-2 font-subheading flex items-center gap-2">
          ✨ حکیم انقلاب کا بنیادی نعرہ اور منشور:
        </h3>
        <p class="text-sm sm:text-base leading-relaxed font-semibold italic">
          "ہم نے طب کو علامات کی بھول بھلیوں اور اندھے تکوں سے نکال کر بافتوں (Tissues) اور اعضاء رئیسہ کے افعال کے ساتھ مربوط کر کے ایک قطعی اور یقینی سائنس بنا دیا ہے۔"
        </p>
      </div>

      <h2 class="text-xl sm:text-2xl font-bold text-pansar-900 mt-7 mb-3 font-title">
        1. ولادت اور ابتدائی علمی سفر
      </h2>
      <p class="text-gray-700 leading-relaxed mb-4">
        حکیم دوست محمد صابر ملتانیؒ 1906ء کے لگ بھگ پنجاب کے تاریخی شہر ملتان میں پیدا ہوئے۔ آپ نے ابتدائی تعلیم و تربیت کے بعد روایتی طبِ یونانی اور علم الابدان پر گہری دسترس حاصل کی۔ آپ نے نہ صرف قدیم یونانی و اسلامی اطباء (جیسے بقراط، جالینوس، بو علی سینا اور علامہ نفیس) کے کتب کا باریک بینی سے مطالعہ کیا، بلکہ جدید مغربی میڈیکل سائنس، ہسٹالوجی (Histology) اور پیتھالوجی (Pathology) کا بھی عمیق مشاہدہ کیا۔
      </p>

      <h2 class="text-xl sm:text-2xl font-bold text-pansar-900 mt-7 mb-3 font-title">
        2. تجدیدِ طب کی ضرورت کیوں پیش آئی؟
      </h2>
      <p class="text-gray-700 leading-relaxed mb-4">
        قدیم طب میں بیماریوں کو ہزاروں متفرق علامات کے تحت بیان کیا جاتا تھا جس کی وجہ سے اکثر اطباء تشخیص میں الجھن کا شکار ہو جاتے تھے اور علاج محض تجرباتی بن چکا تھا۔ حکیم صابر ملتانیؒ نے محسوس کیا کہ جب تک امراض کی تشخیص کا کوئی قطعی، سائنسی اور ریاضیاتی فارمولا وضع نہ کیا جائے، تب تک دیسی طب جدید دور کے چیلنجز کا مقابلہ نہیں کر سکتی۔
      </p>

      <h2 class="text-xl sm:text-2xl font-bold text-pansar-900 mt-7 mb-3 font-title">
        3. قانون مفرد اعضاء کا بنیادی سائنسی نظریہ
      </h2>
      <p class="text-gray-700 leading-relaxed mb-3">
        حکیم صابر ملتانیؒ نے تحقیق کے بعد یہ عظیم حقیقت آشکار کی کہ انسانی جسم تمام تر پیچیدگیوں کے باوجود <strong>تین بنیادی اعضاء رئیسہ</strong> اور ان سے جڑی <strong>تین بنیادی بافتوں (Primary Tissues)</strong> پر مشتمل ہے:
      </p>

      <div class="grid grid-cols-1 sm:grid-cols-3 gap-3 my-5">
        <div class="p-4 rounded-2xl bg-blue-50 border border-blue-200 text-right">
          <span className="text-xs font-bold text-blue-900 block mb-1">1. اعصاب و دماغ (Nervous System)</span>
          <p class="text-xs text-blue-800 leading-relaxed">
            احساس، رطوبات اور بلغمی خلط کا مرکز۔ مزاج: تر و سرد۔
          </p>
        </div>
        <div class="p-4 rounded-2xl bg-rose-50 border border-rose-200 text-right">
          <span className="text-xs font-bold text-rose-900 block mb-1">2. عضلات و قلب (Muscular System)</span>
          <p class="text-xs text-rose-800 leading-relaxed">
            حرکت، انقباض اور سوداوی خلط کا مرکز۔ مزاج: خشک و گرم۔
          </p>
        </div>
        <div class="p-4 rounded-2xl bg-amber-50 border border-amber-200 text-right">
          <span className="text-xs font-bold text-amber-900 block mb-1">3. غدد و جگر (Glandular System)</span>
          <p class="text-xs text-amber-800 leading-relaxed">
            حرارت، تحلیل اور صفراوی خلط کا مرکز۔ مزاج: گرم و خشک۔
          </p>
        </div>
      </div>

      <h2 class="text-xl sm:text-2xl font-bold text-pansar-900 mt-7 mb-3 font-title">
        4. نظریہ تحریک، تسکین اور تحلیل (Triple-T Formula)
      </h2>
      <p class="text-gray-700 leading-relaxed mb-4">
        حکیم صابر ملتانیؒ کا سب سے بڑا سائنسی انکشاف <strong>تحریک، تسکین اور تحلیل</strong> کا باہمی تعلق ہے۔ آپ نے ثابت کیا کہ:
      </p>
      <ul class="list-disc list-inside space-y-2 text-gray-700 leading-relaxed mb-4">
        <li>جب کسی ایک مفرد عضو میں <strong>تحریک (سوزش / Hyper-function)</strong> پیدا ہوتی ہے، تو...</li>
        <li>اس کے اگلے عضو میں خودکار طور پر <strong>تحلیل (کمزوری / Waste)</strong> واقع ہو جاتی ہے، اور...</li>
        <li>پچھلے عضو میں <strong>تسکین (جمود / Sedation)</strong> واقع ہو جاتی ہے۔</li>
      </ul>
      <p class="text-gray-700 leading-relaxed mb-4">
        لہٰذا علاج کا طریقہ یہ ہے کہ جس عضو میں تسکین ہو، دوا اور غذا کے ذریعے اس میں تحریک پیدا کر دی جائے، جس سے بیمار عضو کی سوزش خودبخود تحلیل ہو کر جسم اپنی اصل صحت پر لوٹ آتا ہے۔
      </p>

      <h2 class="text-xl sm:text-2xl font-bold text-pansar-900 mt-7 mb-3 font-title">
        5. کلینیکل نبض شناسی میں انقلاب
      </h2>
      <p class="text-gray-700 leading-relaxed mb-4">
        حکیم صابر ملتانیؒ نے نبض کو قدیم مبہم اصطلاحات کے بجائے <strong>چھ بنیادی نبضوں</strong> میں تقسیم کیا جو اعصاب، عضلات اور غدد کی طبعی و غیر طبعی حرکات کی مکمل عکاسی کرتی ہیں۔ ایک تربیت یافتہ طبیب مریض کی کلائی پر انگلیاں رکھتے ہی ایک منٹ کے اندر مرض کے مقام، نوعیت اور خلط کا سو فیصد درست تعین کر سکتا ہے۔
      </p>

      <h2 class="text-xl sm:text-2xl font-bold text-pansar-900 mt-7 mb-3 font-title">
        6. شاہکار تصانیف اور علمی ورثہ
      </h2>
      <p class="text-gray-700 leading-relaxed mb-3">
        حکیم انقلاب صابر ملتانیؒ نے درجنوں نایاب اور مستند کتب تصنیف فرمائیں جو آج بھی طبِ مشرقی کا مستند ترین نصاب ہیں، جن میں سرِفہرست:
      </p>
      <ul class="list-disc list-inside space-y-2 text-gray-700 leading-relaxed mb-4">
        <li><strong>قانون مفرد اعضاء (مکمل علمی و سائنسی فلسفہ)</strong></li>
        <li><strong>کلینیکل نبض شناسی و تشخیصِ امراض</strong></li>
        <li><strong>میزان الادویہ و فارماکوپیا قانون مفرد اعضاء</strong></li>
        <li><strong>تحقیقاتِ اغذیہ و غذائی چارٹ (1 تا 6)</strong></li>
        <li><strong>تحقیقات و علاج امراضِ جگر و معدہ</strong></li>
      </ul>

      <div class="my-6 p-5 rounded-2xl bg-amber-50 border-r-4 border-amber-600 text-amber-950">
        <h4 class="font-bold text-amber-900 mb-1.5 font-subheading flex items-center gap-1.5">
          🌿 دواخانہ طب پاکستانی کا عزم:
        </h4>
        <p class="text-sm leading-relaxed">
          ہمارا دواخانہ اور ہمالین پنسار سٹور حکیم انقلاب صابر ملتانیؒ کے خالص اصولوں کے عین مطابق معیاری جڑی بوٹیاں، خالص ادویات اور سائنسی مزاجی تشخیص پر گامزن ہے تاکہ انسانیت کو قدرتی علاج کی برکات سے مستفید کیا جا سکے۔
        </p>
      </div>
    `,
    contentHtml: `
      <p class="lead text-lg font-medium text-gray-800 leading-relaxed mb-4">
        برصغیر پاک و ہند کی طبی تاریخ میں <strong>حکیم انقلاب دوست محمد صابر ملتانی رحمہ اللہ</strong> وہ عبقری اور انقلابی شخصیت ہیں جنہوں نے روایتی طب کو محض تجرباتی اور فرسودہ نسخہ جات کی قید سے نکال کر جدید فزیالوجی (Physiology) اور اناٹومی (Anatomy) کی ٹھوس سائنسی بنیادوں پر استوار کیا۔ آپ کا پیش کردہ <strong>"قانون مفرد اعضاء" (Tibb-e-Pakistani)</strong> علمِ طب کی تاریخ میں ایک لازوال سائنسی کارنامہ ہے۔
      </p>

      <div class="my-6 p-5 rounded-2xl bg-emerald-50 border-r-4 border-emerald-700 text-emerald-950">
        <h3 class="text-base font-bold text-emerald-900 mb-2 font-subheading flex items-center gap-2">
          ✨ حکیم انقلاب کا بنیادی نعرہ اور منشور:
        </h3>
        <p class="text-sm sm:text-base leading-relaxed font-semibold italic">
          "ہم نے طب کو علامات کی بھول بھلیوں اور اندھے تکوں سے نکال کر بافتوں (Tissues) اور اعضاء رئیسہ کے افعال کے ساتھ مربوط کر کے ایک قطعی اور یقینی سائنس بنا دیا ہے۔"
        </p>
      </div>

      <h2 class="text-xl sm:text-2xl font-bold text-pansar-900 mt-7 mb-3 font-title">
        1. ولادت اور ابتدائی علمی سفر
      </h2>
      <p class="text-gray-700 leading-relaxed mb-4">
        حکیم دوست محمد صابر ملتانیؒ 1906ء کے لگ بھگ پنجاب کے تاریخی شہر ملتان میں پیدا ہوئے۔ آپ نے ابتدائی تعلیم و تربیت کے بعد روایتی طبِ یونانی اور علم الابدان پر گہری دسترس حاصل کی۔ آپ نے نہ صرف قدیم یونانی و اسلامی اطباء (جیسے بقراط، جالینوس، بو علی سینا اور علامہ نفیس) کے کتب کا باریک بینی سے مطالعہ کیا، بلکہ جدید مغربی میڈیکل سائنس، ہسٹالوجی (Histology) اور پیتھالوجی (Pathology) کا بھی عمیق مشاہدہ کیا۔
      </p>

      <h2 class="text-xl sm:text-2xl font-bold text-pansar-900 mt-7 mb-3 font-title">
        2. تجدیدِ طب کی ضرورت کیوں پیش آئی؟
      </h2>
      <p class="text-gray-700 leading-relaxed mb-4">
        قدیم طب میں بیماریوں کو ہزاروں متفرق علامات کے تحت بیان کیا جاتا تھا جس کی وجہ سے اکثر اطباء تشخیص میں الجھن کا شکار ہو جاتے تھے اور علاج محض تجرباتی بن چکا تھا۔ حکیم صابر ملتانیؒ نے محسوس کیا کہ جب تک امراض کی تشخیص کا کوئی قطعی، سائنسی اور ریاضیاتی فارمولا وضع نہ کیا جائے، تب تک دیسی طب جدید دور کے چیلنجز کا مقابلہ نہیں کر سکتی۔
      </p>

      <h2 class="text-xl sm:text-2xl font-bold text-pansar-900 mt-7 mb-3 font-title">
        3. قانون مفرد اعضاء کا بنیادی سائنسی نظریہ
      </h2>
      <p class="text-gray-700 leading-relaxed mb-3">
        حکیم صابر ملتانیؒ نے تحقیق کے بعد یہ عظیم حقیقت آشکار کی کہ انسانی جسم تمام تر پیچیدگیوں کے باوجود <strong>تین بنیادی اعضاء رئیسہ</strong> اور ان سے جڑی <strong>تین بنیادی بافتوں (Primary Tissues)</strong> پر مشتمل ہے:
      </p>

      <div class="grid grid-cols-1 sm:grid-cols-3 gap-3 my-5">
        <div class="p-4 rounded-2xl bg-blue-50 border border-blue-200 text-right">
          <span className="text-xs font-bold text-blue-900 block mb-1">1. اعصاب و دماغ (Nervous System)</span>
          <p class="text-xs text-blue-800 leading-relaxed">
            احساس، رطوبات اور بلغمی خلط کا مرکز۔ مزاج: تر و سرد۔
          </p>
        </div>
        <div class="p-4 rounded-2xl bg-rose-50 border border-rose-200 text-right">
          <span className="text-xs font-bold text-rose-900 block mb-1">2. عضلات و قلب (Muscular System)</span>
          <p class="text-xs text-rose-800 leading-relaxed">
            حرکت، انقباض اور سوداوی خلط کا مرکز۔ مزاج: خشک و گرم۔
          </p>
        </div>
        <div class="p-4 rounded-2xl bg-amber-50 border border-amber-200 text-right">
          <span className="text-xs font-bold text-amber-900 block mb-1">3. غدد و جگر (Glandular System)</span>
          <p class="text-xs text-amber-800 leading-relaxed">
            حرارت، تحلیل اور صفراوی خلط کا مرکز۔ مزاج: گرم و خشک۔
          </p>
        </div>
      </div>

      <h2 class="text-xl sm:text-2xl font-bold text-pansar-900 mt-7 mb-3 font-title">
        4. نظریہ تحریک، تسکین اور تحلیل (Triple-T Formula)
      </h2>
      <p class="text-gray-700 leading-relaxed mb-4">
        حکیم صابر ملتانیؒ کا سب سے بڑا سائنسی انکشاف <strong>تحریک، تسکین اور تحلیل</strong> کا باہمی تعلق ہے۔ آپ نے ثابت کیا کہ:
      </p>
      <ul class="list-disc list-inside space-y-2 text-gray-700 leading-relaxed mb-4">
        <li>جب کسی ایک مفرد عضو میں <strong>تحریک (سوزش / Hyper-function)</strong> پیدا ہوتی ہے، تو...</li>
        <li>اس کے اگلے عضو میں خودکار طور پر <strong>تحلیل (کمزوری / Waste)</strong> واقع ہو جاتی ہے، اور...</li>
        <li>پچھلے عضو میں <strong>تسکین (جمود / Sedation)</strong> واقع ہو جاتی ہے۔</li>
      </ul>
      <p class="text-gray-700 leading-relaxed mb-4">
        لہٰذا علاج کا طریقہ یہ ہے کہ جس عضو میں تسکین ہو، دوا اور غذا کے ذریعے اس میں تحریک پیدا کر دی جائے، جس سے بیمار عضو کی سوزش خودبخود تحلیل ہو کر جسم اپنی اصل صحت پر لوٹ آتا ہے۔
      </p>

      <h2 class="text-xl sm:text-2xl font-bold text-pansar-900 mt-7 mb-3 font-title">
        5. کلینیکل نبض شناسی میں انقلاب
      </h2>
      <p class="text-gray-700 leading-relaxed mb-4">
        حکیم صابر ملتانیؒ نے نبض کو قدیم مبہم اصطلاحات کے بجائے <strong>چھ بنیادی نبضوں</strong> میں تقسیم کیا جو اعصاب، عضلات اور غدد کی طبعی و غیر طبعی حرکات کی مکمل عکاسی کرتی ہیں۔ ایک تربیت یافتہ طبیب مریض کی کلائی پر انگلیاں رکھتے ہی ایک منٹ کے اندر مرض کے مقام، نوعیت اور خلط کا سو فیصد درست تعین کر سکتا ہے۔
      </p>

      <h2 class="text-xl sm:text-2xl font-bold text-pansar-900 mt-7 mb-3 font-title">
        6. شاہکار تصانیف اور علمی ورثہ
      </h2>
      <p class="text-gray-700 leading-relaxed mb-3">
        حکیم انقلاب صابر ملتانیؒ نے درجنوں نایاب اور مستند کتب تصنیف فرمائیں جو آج بھی طبِ مشرقی کا مستند ترین نصاب ہیں، جن میں سرِفہرست:
      </p>
      <ul class="list-disc list-inside space-y-2 text-gray-700 leading-relaxed mb-4">
        <li><strong>قانون مفرد اعضاء (مکمل علمی و سائنسی فلسفہ)</strong></li>
        <li><strong>کلینیکل نبض شناسی و تشخیصِ امراض</strong></li>
        <li><strong>میزان الادویہ و فارماکوپیا قانون مفرد اعضاء</strong></li>
        <li><strong>تحقیقاتِ اغذیہ و غذائی چارٹ (1 تا 6)</strong></li>
        <li><strong>تحقیقات و علاج امراضِ جگر و معدہ</strong></li>
      </ul>

      <div class="my-6 p-5 rounded-2xl bg-amber-50 border-r-4 border-amber-600 text-amber-950">
        <h4 class="font-bold text-amber-900 mb-1.5 font-subheading flex items-center gap-1.5">
          🌿 دواخانہ طب پاکستانی کا عزم:
        </h4>
        <p class="text-sm leading-relaxed">
          ہمارا دواخانہ اور ہمالین پنسار سٹور حکیم انقلاب صابر ملتانیؒ کے خالص اصولوں کے عین مطابق معیاری جڑی بوٹیاں، خالص ادویات اور سائنسی مزاجی تشخیص پر گامزن ہے تاکہ انسانیت کو قدرتی علاج کی برکات سے مستفید کیا جا سکے۔
        </p>
      </div>
    `
  },
  {
    id: 'blog-1',
    slug: 'kalonji-benefits-and-usage',
    title: 'کلونجی کے طبی فوائد، نبویؐ رہنمائی اور جدید سائنسی تحقیقات',
    titleUrdu: 'کلونجی کے طبی فوائد، نبویؐ رہنمائی اور جدید سائنسی تحقیقات',
    titleEn: 'Health Benefits and Medical Uses of Pure Kalonji (Black Seed)',
    category: 'herbs',
    categoryUrdu: 'جڑی بوٹیاں و نباتات',
    coverImage: 'https://images.unsplash.com/photo-1620916566398-39f1143ab7be?w=1200&auto=format&fit=crop&q=80',
    featuredImage: 'https://images.unsplash.com/photo-1620916566398-39f1143ab7be?w=1200&auto=format&fit=crop&q=80',
    author: 'حکیم مولانا سید عبدالوہاب شاہ شیرازی',
    authorTitle: 'فاضل طب والجراحت (FTJ) - ماہر قانون مفرد اعضاء',
    publishedDate: '2026-09-08',
    readTime: '6 منٹ',
    viewsCount: 384,
    status: 'published',
    linkedProductId: 'prod-1',
    excerpt: 'کلونجی کو موت کے علاوہ ہر بیماری کی شفا قرار دیا گیا ہے۔ قانون مفرد اعضاء کے تحت اس کا مزاج، امراضِ معدہ، قوتِ مدافعت اور بلغمی امراض میں اس کے مستند طریقہ استعمال کی مکمل تحقیق۔',
    excerptUrdu: 'کلونجی کو موت کے علاوہ ہر بیماری کی شفا قرار دیا گیا ہے۔ قانون مفرد اعضاء کے تحت اس کا مزاج، امراضِ معدہ، قوتِ مدافعت اور بلغمی امراض میں اس کے مستند طریقہ استعمال کی مکمل تحقیق۔',
    excerptEn: 'Detailed clinical guide on Kalonji (Black Seed) temperament, dosage, immunity enhancement, and digestive health according to Tibb-e-Pakistani principles.',
    tags: ['کلونجی', 'طب نبوی', 'قانون مفرد اعضاء', 'قوت مدافعت', 'ہاضمہ'],
    seoTitle: 'کلونجی کے طبی فوائد اور طریقہ استعمال | ہمالین پنسار سٹور',
    seoDescription: 'خالص کلونجی کے حیرت انگیز فوائد، مزاج، مقدار خوراک اور طریقہ استعمال۔ حکیم سید عبدالوہاب شاہ شیرازی کی تحقیقی تحریر۔',
    seoKeywords: 'کلونجی فوائد, black seed benefits, طب پاکستانی, کلونجی کا مزاج, جڑی بوٹیاں',
    content: `
      <p class="lead text-lg font-medium text-gray-800 leading-relaxed mb-4">
        کلونجی کو اسلامی طب اور روایتی حکمت میں غیر معمولی فضیلت اور افادیت حاصل ہے۔ فرمانِ نبوی ﷺ کے مطابق <em>"کلونجی میں سوائے موت کے ہر بیماری کی شفا ہے"</em>۔ جدید سائنسی تحقیقات نے بھی ثابت کیا ہے کہ کلونجی میں موجود فعال جزو <strong>تھاموکوئینون (Thymoquinone)</strong> طاقتور اینٹی آکسیڈنٹ اور اینٹی انفلیمیٹری خصوصیات کا حامل ہے۔
      </p>

      <h2 class="text-xl sm:text-2xl font-bold text-pansar-900 mt-6 mb-3 font-title">
        1. قانون مفرد اعضاء کی روشنی میں کلونجی کا مزاج
      </h2>
      <p class="text-gray-700 leading-relaxed mb-4">
        قانون مفرد اعضاء (نظریہ صابر ملتانیؒ) کے مطابق کلونجی کا مزاج <strong>عضلاتی غدی (خشک گرم)</strong> ہے۔ یہ جسم میں موجود اضافی رطوبات، بلغم اور سستی کو ختم کر کے حرارتِ غریزیہ کو بیدار کرتی ہے اور عضلات و دل کو تقویت فراہم کرتی ہے۔
      </p>

      <div class="my-5 p-4 rounded-2xl bg-emerald-50 border-r-4 border-emerald-600 text-emerald-950">
        <h4 class="font-bold text-emerald-900 mb-1 flex items-center gap-1.5 font-subheading">
          🌿 طبی نکتہ:
        </h4>
        <p class="text-sm leading-relaxed">
          جن افراد کا مزاج اعصابی بلغمی (سرد تر) ہو، جنہیں ہر وقت سستی، موٹاپا، جوڑوں میں سردی اور نزلہ زکام رہتا ہو، ان کے لیے کلونجی آبِ حیات کی مانند ہے۔
        </p>
      </div>

      <h2 class="text-xl sm:text-2xl font-bold text-pansar-900 mt-6 mb-3 font-title">
        2. کلونجی کے اہم ترین طبی فوائد
      </h2>
      <ul class="list-disc list-inside space-y-2 text-gray-700 leading-relaxed mb-4">
        <li><strong>معدے اور ہاضمے کی اصلاح:</strong> پیٹ کا پھولنا، گیس، تبخیر اور ریاحی دردوں کو فوراً تحلیل کرتی ہے۔</li>
        <li><strong>قوتِ مدافعت میں اضافہ:</strong> جسم کو موسمی بیماریوں، وائرل انفیکشن اور الرجی سے تحفظ دیتی ہے۔</li>
        <li><strong>خون کی گردش اور قلبی طاقت:</strong> خون میں مضر کولیسٹرول (LDL) کو کم کر کے شریانوں کی لچک بحال رکھتی ہے۔</li>
        <li><strong>سانس اور دمہ میں راحت:</strong> پھیپھڑوں میں جمی ہوئی بلغم خارج کر کے سانس کی تنگی کو دور کرتی ہے۔</li>
      </ul>

      <div class="my-5 p-4 rounded-2xl bg-amber-50 border-r-4 border-amber-600 text-amber-950">
        <h4 class="font-bold text-amber-900 mb-1 flex items-center gap-1.5 font-subheading">
          🍯 مجرب طریقہ استعمال:
        </h4>
        <p class="text-sm leading-relaxed">
          روزانہ صبح نہار منہ 7 سے 11 دانے کلونجی چبا کر ایک چمچ خالص شہد کے ساتھ نیم گرم پانی سے کھائیں۔ یہ نسخہ جسمانی چستی اور امراض سے نجات کا مجرب راز ہے۔
        </p>
      </div>

      <h2 class="text-xl sm:text-2xl font-bold text-pansar-900 mt-6 mb-3 font-title">
        3. احتیاطی تدابیر
      </h2>
      <p class="text-gray-700 leading-relaxed mb-3">
        کلونجی کی مقدار خوراک ہمیشہ معتدل رکھیں۔ گرم خشک مزاج والے افراد اور حاملہ خواتین معالج کے مشورے کے بغیر زیادہ مقدار میں استعمال نہ کریں۔
      </p>
    `,
    contentHtml: `
      <p class="lead text-lg font-medium text-gray-800 leading-relaxed mb-4">
        کلونجی کو اسلامی طب اور روایتی حکمت میں غیر معمولی فضیلت اور افادیت حاصل ہے۔ فرمانِ نبوی ﷺ کے مطابق <em>"کلونجی میں سوائے موت کے ہر بیماری کی شفا ہے"</em>۔ جدید سائنسی تحقیقات نے بھی ثابت کیا ہے کہ کلونجی میں موجود فعال جزو <strong>تھاموکوئینون (Thymoquinone)</strong> طاقتور اینٹی آکسیڈنٹ اور اینٹی انفلیمیٹری خصوصیات کا حامل ہے۔
      </p>

      <h2 class="text-xl sm:text-2xl font-bold text-pansar-900 mt-6 mb-3 font-title">
        1. قانون مفرد اعضاء کی روشنی میں کلونجی کا مزاج
      </h2>
      <p class="text-gray-700 leading-relaxed mb-4">
        قانون مفرد اعضاء (نظریہ صابر ملتانیؒ) کے مطابق کلونجی کا مزاج <strong>عضلاتی غدی (خشک گرم)</strong> ہے۔ یہ جسم میں موجود اضافی رطوبات، بلغم اور سستی کو ختم کر کے حرارتِ غریزیہ کو بیدار کرتی ہے اور عضلات و دل کو تقویت فراہم کرتی ہے۔
      </p>

      <div class="my-5 p-4 rounded-2xl bg-emerald-50 border-r-4 border-emerald-600 text-emerald-950">
        <h4 class="font-bold text-emerald-900 mb-1 flex items-center gap-1.5 font-subheading">
          🌿 طبی نکتہ:
        </h4>
        <p class="text-sm leading-relaxed">
          جن افراد کا مزاج اعصابی بلغمی (سرد تر) ہو، جنہیں ہر وقت سستی، موٹاپا، جوڑوں میں سردی اور نزلہ زکام رہتا ہو، ان کے لیے کلونجی آبِ حیات کی مانند ہے۔
        </p>
      </div>

      <h2 class="text-xl sm:text-2xl font-bold text-pansar-900 mt-6 mb-3 font-title">
        2. کلونجی کے اہم ترین طبی فوائد
      </h2>
      <ul class="list-disc list-inside space-y-2 text-gray-700 leading-relaxed mb-4">
        <li><strong>معدے اور ہاضمے کی اصلاح:</strong> پیٹ کا پھولنا، گیس، تبخیر اور ریاحی دردوں کو فوراً تحلیل کرتی ہے۔</li>
        <li><strong>قوتِ مدافعت میں اضافہ:</strong> جسم کو موسمی بیماریوں، وائرل انفیکشن اور الرجی سے تحفظ دیتی ہے۔</li>
        <li><strong>خون کی گردش اور قلبی طاقت:</strong> خون میں مضر کولیسٹرول (LDL) کو کم کر کے شریانوں کی لچک بحال رکھتی ہے۔</li>
        <li><strong>سانس اور دمہ میں راحت:</strong> پھیپھڑوں میں جمی ہوئی بلغم خارج کر کے سانس کی تنگی کو دور کرتی ہے۔</li>
      </ul>

      <div class="my-5 p-4 rounded-2xl bg-amber-50 border-r-4 border-amber-600 text-amber-950">
        <h4 class="font-bold text-amber-900 mb-1 flex items-center gap-1.5 font-subheading">
          🍯 مجرب طریقہ استعمال:
        </h4>
        <p class="text-sm leading-relaxed">
          روزانہ صبح نہار منہ 7 سے 11 دانے کلونجی چبا کر ایک چمچ خالص شہد کے ساتھ نیم گرم پانی سے کھائیں۔ یہ نسخہ جسمانی چستی اور امراض سے نجات کا مجرب راز ہے۔
        </p>
      </div>

      <h2 class="text-xl sm:text-2xl font-bold text-pansar-900 mt-6 mb-3 font-title">
        3. احتیاطی تدابیر
      </h2>
      <p class="text-gray-700 leading-relaxed mb-3">
        کلونجی کی مقدار خوراک ہمیشہ معتدل رکھیں۔ گرم خشک مزاج والے افراد اور حاملہ خواتین معالج کے مشورے کے بغیر زیادہ مقدار میں استعمال نہ کریں۔
      </p>
    `
  },
  {
    id: 'blog-2',
    slug: 'tibb-e-pakistani-six-mizaj-and-pulse',
    title: 'قانون مفرد اعضاء: چھ بنیادی مزاج اور نبض شناسی کا آسان طریقہ',
    titleUrdu: 'قانون مفرد اعضاء: چھ بنیادی مزاج اور نبض شناسی کا آسان طریقہ',
    titleEn: 'Understanding the 6 Temperaments & Pulse Diagnosis in Tibb-e-Pakistani',
    category: 'theory',
    categoryUrdu: 'قانون مفرد اعضاء',
    coverImage: 'https://images.unsplash.com/photo-1514733670139-4d87a1941d55?w=1200&auto=format&fit=crop&q=80',
    featuredImage: 'https://images.unsplash.com/photo-1514733670139-4d87a1941d55?w=1200&auto=format&fit=crop&q=80',
    author: 'حکیم مولانا سید عبدالوہاب شاہ شیرازی',
    authorTitle: 'فاضل طب والجراحت (FTJ) - ماہر قانون مفرد اعضاء',
    publishedDate: '2026-09-09',
    readTime: '8 منٹ',
    viewsCount: 512,
    status: 'published',
    linkedProductId: 'prod-2',
    excerpt: 'صابر ملتانیؒ کے عظیم سائنسی طبی نظریے کی مکمل تفہیم: اعصابی، عضلاتی اور غدی تحریکات کی شناخت، نبض سے بیماری جانچنے کے بنیادی اصول اور درست غذائی علاج کا طریقہ۔',
    excerptUrdu: 'صابر ملتانیؒ کے عظیم سائنسی طبی نظریے کی مکمل تفہیم: اعصابی، عضلاتی اور غدی تحریکات کی شناخت، نبض سے بیماری جانچنے کے بنیادی اصول اور درست غذائی علاج کا طریقہ۔',
    excerptEn: 'Comprehensive guide to pulse reading (Nabz Shanasi) and the 6 organ-based temperaments according to Sabir Multani theory.',
    tags: ['قانون مفرد اعضاء', 'نبض شناسی', 'صابر ملتانی', 'تشخیص', 'طب پاکستانی'],
    seoTitle: 'چھ بنیادی مزاج اور نبض شناسی کا طریقہ | قانون مفرد اعضاء',
    seoDescription: 'قانون مفرد اعضاء کے مطابق نبض شناسی، اعصابی، عضلاتی اور غدی مزاج کی پہچان اور علاج بالغذا کا مکمل رہنما مضمون۔',
    seoKeywords: 'نبض شناسی, قانون مفرد اعضاء, صابر ملتانی, چھ مزاج, طب پاکستانی',
    content: `
      <p class="lead text-lg font-medium text-gray-800 leading-relaxed mb-4">
        جناب صابر ملتانیؒ کا پیش کردہ نظریہ <strong>قانون مفرد اعضاء</strong> انسانی جسم کی بناوٹ اور اعضاء رئیسہ (دماغ، دل، جگر) کے باہمی تعلق پر مبنی ایک مکمل سائنسی طب ہے۔ اس طب کا بنیادی اصول یہ ہے کہ بیماری کسی ایک بافت (Tissue) یا عضو میں غیر طبعی تحریک سے جنم لیتی ہے۔
      </p>

      <h2 class="text-xl sm:text-2xl font-bold text-pansar-900 mt-6 mb-3 font-title">
        1. جسم کے تین بنیادی مفرد اعضاء
      </h2>
      <p class="text-gray-700 leading-relaxed mb-3">
        انسانی جسم تمام تر پیچیدگیوں کے باوجود تین مفرد اعضاء کے نظام پر قائم ہے:
      </p>
      <ul class="list-disc list-inside space-y-2 text-gray-700 leading-relaxed mb-4">
        <li><strong>اعصاب و دماغ (Nervous System):</strong> احساس اور رطوبت پیدا کرتا ہے (تری و سردی)۔</li>
        <li><strong>عضلات و قلب (Muscular System):</strong> حرکت اور ریاح پیدا کرتا ہے (خشکی و سردی/گرمی)۔</li>
        <li><strong>غدد و جگر (Glandular System):</strong> حرارت اور صفراء پیدا کرتا ہے (گرمی و خشکی/تری)۔</li>
      </ul>

      <div class="my-5 p-4 rounded-2xl bg-emerald-50 border-r-4 border-emerald-600 text-emerald-950">
        <h4 class="font-bold text-emerald-900 mb-1 flex items-center gap-1.5 font-subheading">
          🩺 نبض شناسی کا بنیادی اصول:
        </h4>
        <p class="text-sm leading-relaxed">
          دائیں ہاتھ کی چار انگلیوں سے کلائی پر نبض کا مقام، گہرائی، اور حرکت دیکھ کر فوری طور پر معلوم کیا جا سکتا ہے کہ جسم کے کس عضو میں سوزش یا خرابی ہے۔
        </p>
      </div>

      <h2 class="text-xl sm:text-2xl font-bold text-pansar-900 mt-6 mb-3 font-title">
        2. علاج کا سنہری قانون (تحریک، تسکین، تحلیل)
      </h2>
      <p class="text-gray-700 leading-relaxed mb-4">
        جس عضو میں تحریک (سوزش) ہو، اس کے اگلے عضو میں تحریک پیدا کر کے پچھلے عضو کو تسکین دی جاتی ہے جس سے بیماری بغیر کسی سائیڈ ایفیکٹ کے جڑ سے ختم ہو جاتی ہے۔ اسی لیے طبِ پاکستانی میں دوا کے ساتھ ساتھ <strong>غذائی چارٹ (1 تا 6)</strong> کو مرکزی حیثیت حاصل ہے۔
      </p>
    `,
    contentHtml: `
      <p class="lead text-lg font-medium text-gray-800 leading-relaxed mb-4">
        جناب صابر ملتانیؒ کا پیش کردہ نظریہ <strong>قانون مفرد اعضاء</strong> انسانی جسم کی بناوٹ اور اعضاء رئیسہ (دماغ، دل، جگر) کے باہمی تعلق پر مبنی ایک مکمل سائنسی طب ہے۔ اس طب کا بنیادی اصول یہ ہے کہ بیماری کسی ایک بافت (Tissue) یا عضو میں غیر طبعی تحریک سے جنم لیتی ہے۔
      </p>

      <h2 class="text-xl sm:text-2xl font-bold text-pansar-900 mt-6 mb-3 font-title">
        1. جسم کے تین بنیادی مفرد اعضاء
      </h2>
      <p class="text-gray-700 leading-relaxed mb-3">
        انسانی جسم تمام تر پیچیدگیوں کے باوجود تین مفرد اعضاء کے نظام پر قائم ہے:
      </p>
      <ul class="list-disc list-inside space-y-2 text-gray-700 leading-relaxed mb-4">
        <li><strong>اعصاب و دماغ (Nervous System):</strong> احساس اور رطوبت پیدا کرتا ہے (تری و سردی)۔</li>
        <li><strong>عضلات و قلب (Muscular System):</strong> حرکت اور ریاح پیدا کرتا ہے (خشکی و سردی/گرمی)۔</li>
        <li><strong>غدد و جگر (Glandular System):</strong> حرارت اور صفراء پیدا کرتا ہے (گرمی و خشکی/تری)۔</li>
      </ul>

      <div class="my-5 p-4 rounded-2xl bg-emerald-50 border-r-4 border-emerald-600 text-emerald-950">
        <h4 class="font-bold text-emerald-900 mb-1 flex items-center gap-1.5 font-subheading">
          🩺 نبض شناسی کا بنیادی اصول:
        </h4>
        <p class="text-sm leading-relaxed">
          دائیں ہاتھ کی چار انگلیوں سے کلائی پر نبض کا مقام، گہرائی، اور حرکت دیکھ کر فوری طور پر معلوم کیا جا سکتا ہے کہ جسم کے کس عضو میں سوزش یا خرابی ہے۔
        </p>
      </div>

      <h2 class="text-xl sm:text-2xl font-bold text-pansar-900 mt-6 mb-3 font-title">
        2. علاج کا سنہری قانون (تحریک، تسکین، تحلیل)
      </h2>
      <p class="text-gray-700 leading-relaxed mb-4">
        جس عضو میں تحریک (سوزش) ہو، اس کے اگلے عضو میں تحریک پیدا کر کے پچھلے عضو کو تسکین دی جاتی ہے جس سے بیماری بغیر کسی سائیڈ ایفیکٹ کے جڑ سے ختم ہو جاتی ہے۔ اسی لیے طبِ پاکستانی میں دوا کے ساتھ ساتھ <strong>غذائی چارٹ (1 تا 6)</strong> کو مرکزی حیثیت حاصل ہے۔
      </p>
    `
  },
  {
    id: 'blog-3',
    slug: 'pure-himalayan-shilajit-guide',
    title: 'خالص پہاڑی سلاجیت: اصلیت کی پہچان، طبی فوائد اور درست طریقہ استعمال',
    titleUrdu: 'خالص پہاڑی سلاجیت: اصلیت کی پہچان، طبی فوائد اور درست طریقہ استعمال',
    titleEn: 'Pure Himalayan Shilajit: Purity Testing, Vitality Benefits & Correct Usage',
    category: 'vitality',
    categoryUrdu: 'توانائی و مقویات',
    coverImage: '/images/products/shilajit-1.jpg',
    featuredImage: '/images/products/shilajit-1.jpg',
    author: 'حکیم مولانا سید عبدالوہاب شاہ شیرازی',
    authorTitle: 'فاضل طب والجراحت (FTJ) - ماہر قانون مفرد اعضاء',
    publishedDate: '2026-09-10',
    readTime: '7 منٹ',
    viewsCount: 620,
    status: 'published',
    linkedProductId: 'prod-shilajit',
    excerpt: 'ہمالیہ اور قراقرم کے پہاڑوں سے حاصل ہونے والی خالص آفتابی سلاجیت کے حیران کن معدنی فوائد۔ فلوک ایسڈ، جوڑوں کے درد، اعصابی کمزوری اور اصلی و نقلی سلاجیت کی شناخت کا مکمل طریقہ۔',
    excerptUrdu: 'ہمالیہ اور قراقرم کے پہاڑوں سے حاصل ہونے والی خالص آفتابی سلاجیت کے حیران کن معدنی فوائد۔ فلوک ایسڈ، جوڑوں کے درد، اعصابی کمزوری اور اصلی و نقلی سلاجیت کی شناخت کا مکمل طریقہ۔',
    excerptEn: 'Complete guide on pure Himalayan Aftabi Shilajit, fulvic acid benefits, joint pain relief, stamina enhancement, and authenticity tests.',
    tags: ['سلاجیت', 'ہمالین سلاجیت', 'اعصابی کمزوری', 'جوڑوں کا درد', 'فلوک ایسڈ'],
    seoTitle: 'خالص سلاجیت کی پہچان اور طبی فوائد | ہمالین پنسار سٹور',
    seoDescription: 'خالص پہاڑی سلاجیت کی پہچان، طبی فوائد، جوڑوں کے درد اور اعصابی تقویت کے لیے طریقہ استعمال۔',
    seoKeywords: 'shilajit benefits, خالص سلاجیت, سلاجیت کی پہچان, ہمالین سلاجیت, جوڑوں کا درد',
    content: `
      <p class="lead text-lg font-medium text-gray-800 leading-relaxed mb-4">
        سلاجیت کو قدرت کا سب سے نایاب اور قیمتی پہاڑی تحفہ مانا جاتا ہے۔ یہ ہزاروں سالوں کے دوران پہاڑی نباتات کے قدرتی عملِ کشید اور آفتابی دباؤ کے نتیجے میں چٹانوں سے رس کر نکلتی ہے۔ اس میں 84 سے زائد قدرتی معدنیات اور وافر مقدار میں <strong>فلوک ایسڈ (Fulvic Acid)</strong> موجود ہوتا ہے۔
      </p>

      <h2 class="text-xl sm:text-2xl font-bold text-pansar-900 mt-6 mb-3 font-title">
        1. اصلی اور نقلی سلاجیت کی پہچان کیسے کریں؟
      </h2>
      <ul class="list-disc list-inside space-y-2 text-gray-700 leading-relaxed mb-4">
        <li><strong>پانی میں حل پذیری کا ٹیسٹ:</strong> خالص سلاجیت نیم گرم پانی یا دودھ میں ڈالتے ہی بغیر ہلائے سنہری بھورے رنگ کے دھاگوں کی شکل میں حل ہونا شروع ہو جاتی ہے اور نیچے کوئی کچرا نہیں چھوڑتی۔</li>
        <li><strong>آگ کا ٹیسٹ:</strong> خالص سلاجیت کو آگ پر گرم کرنے سے یہ پھیل کر بلبلے بناتی ہے لیکن راکھ کی طرح جلتی نہیں اور نہ ہی اس سے پلاسٹک جیسی بو آتی ہے۔</li>
        <li><strong>درجہ حرارت کا اثر:</strong> گرمی میں نرم اور سردی میں پتھر کی طرح سخت ہو جاتی ہے۔</li>
      </ul>

      <div class="my-5 p-4 rounded-2xl bg-amber-50 border-r-4 border-amber-600 text-amber-950">
        <h4 class="font-bold text-amber-900 mb-1 flex items-center gap-1.5 font-subheading">
          ⚡ اہم ترین فوائد:
        </h4>
        <p class="text-sm leading-relaxed">
          سلاجیت جسم میں مائٹوکونڈریا (سیل انرجی) کو طاقت دیتی ہے، یورک ایسڈ اور جوڑوں کی پرانی سوجن ختم کرتی ہے اور اعصابی تھکن کو فوراً دور کرتی ہے۔
        </p>
      </div>

      <h2 class="text-xl sm:text-2xl font-bold text-pansar-900 mt-6 mb-3 font-title">
        2. درست مقدارِ خوراک
      </h2>
      <p class="text-gray-700 leading-relaxed mb-3">
        سلاجیت گرم تر مزاج کی حامل ہے۔ اس کی روزانہ کی مقدار خوراک صرف ایک <strong>چنے کے دانے کے برابر (تقریباً 300 تا 500 ملی گرام)</strong> ہے، جسے رات کو سونے سے قبل نیم گرم میٹھے دودھ میں گھول کر پیا جاتا ہے۔
      </p>
    `,
    contentHtml: `
      <p class="lead text-lg font-medium text-gray-800 leading-relaxed mb-4">
        سلاجیت کو قدرت کا سب سے نایاب اور قیمتی پہاڑی تحفہ مانا جاتا ہے۔ یہ ہزاروں سالوں کے دوران پہاڑی نباتات کے قدرتی عملِ کشید اور آفتابی دباؤ کے نتیجے میں چٹانوں سے رس کر نکلتی ہے۔ اس میں 84 سے زائد قدرتی معدنیات اور وافر مقدار میں <strong>فلوک ایسڈ (Fulvic Acid)</strong> موجود ہوتا ہے۔
      </p>

      <h2 class="text-xl sm:text-2xl font-bold text-pansar-900 mt-6 mb-3 font-title">
        1. اصلی اور نقلی سلاجیت کی پہچان کیسے کریں؟
      </h2>
      <ul class="list-disc list-inside space-y-2 text-gray-700 leading-relaxed mb-4">
        <li><strong>پانی میں حل پذیری کا ٹیسٹ:</strong> خالص سلاجیت نیم گرم پانی یا دودھ میں ڈالتے ہی بغیر ہلائے سنہری بھورے رنگ کے دھاگوں کی شکل میں حل ہونا شروع ہو جاتی ہے اور نیچے کوئی کچرا نہیں چھوڑتی۔</li>
        <li><strong>آگ کا ٹیسٹ:</strong> خالص سلاجیت کو آگ پر گرم کرنے سے یہ پھیل کر بلبلے بناتی ہے لیکن راکھ کی طرح جلتی نہیں اور نہ ہی اس سے پلاسٹک جیسی بو آتی ہے۔</li>
        <li><strong>درجہ حرارت کا اثر:</strong> گرمی میں نرم اور سردی میں پتھر کی طرح سخت ہو جاتی ہے۔</li>
      </ul>

      <div class="my-5 p-4 rounded-2xl bg-amber-50 border-r-4 border-amber-600 text-amber-950">
        <h4 class="font-bold text-amber-900 mb-1 flex items-center gap-1.5 font-subheading">
          ⚡ اہم ترین فوائد:
        </h4>
        <p class="text-sm leading-relaxed">
          سلاجیت جسم میں مائٹوکونڈریا (سیل انرجی) کو طاقت دیتی ہے، یورک ایسڈ اور جوڑوں کی پرانی سوجن ختم کرتی ہے اور اعصابی تھکن کو فوراً دور کرتی ہے۔
        </p>
      </div>

      <h2 class="text-xl sm:text-2xl font-bold text-pansar-900 mt-6 mb-3 font-title">
        2. درست مقدارِ خوراک
      </h2>
      <p class="text-gray-700 leading-relaxed mb-3">
        سلاجیت گرم تر مزاج کی حامل ہے۔ اس کی روزانہ کی مقدار خوراک صرف ایک <strong>چنے کے دانے کے برابر (تقریباً 300 تا 500 ملی گرام)</strong> ہے، جسے رات کو سونے سے قبل نیم گرم میٹھے دودھ میں گھول کر پیا جاتا ہے۔
      </p>
    `
  },
  {
    id: 'blog-4',
    slug: 'stomach-acidity-gas-gerd-cure',
    title: 'معدے کی تیزابیت، جلن، گیس اور تبخیر کا مستقل غذائی و نباتاتی علاج',
    titleUrdu: 'معدے کی تیزابیت، جلن، گیس اور تبخیر کا مستقل غذائی و نباتاتی علاج',
    titleEn: 'Natural Cure for Stomach Acidity, GERD, Gas & Indigestion in Herbal Medicine',
    category: 'digestion',
    categoryUrdu: 'نظامِ ہاضمہ و معدہ',
    coverImage: 'https://images.unsplash.com/photo-1540420773420-3366772f4999?w=1200&auto=format&fit=crop&q=80',
    featuredImage: 'https://images.unsplash.com/photo-1540420773420-3366772f4999?w=1200&auto=format&fit=crop&q=80',
    author: 'حکیم مولانا سید عبدالوہاب شاہ شیرازی',
    authorTitle: 'فاضل طب والجراحت (FTJ) - ماہر قانون مفرد اعضاء',
    publishedDate: '2026-09-11',
    readTime: '6 منٹ',
    viewsCount: 440,
    status: 'published',
    linkedProductId: 'prod-2',
    excerpt: 'سینے کی جلن، منہ میں کھٹا پانی، بدہضمی اور گیس کا بغیر ایلوپیتھک کیپسول کے مستقل شافی علاج۔ جوارش کمونی اور سونف و پودینہ کا لاجواب غذائی مرکب۔',
    excerptUrdu: 'سینے کی جلن، منہ میں کھٹا پانی، بدہضمی اور گیس کا بغیر ایلوپیتھک کیپسول کے مستقل شافی علاج۔ جوارش کمونی اور سونف و پودینہ کا لاجواب غذائی مرکب۔',
    excerptEn: 'Holistic digestive health guide explaining roots of acidity, acid reflux, flatulence and botanical relief through Jawarish Kamuni & herbal infusions.',
    tags: ['معدہ', 'تیزابیت', 'گیس کا علاج', 'جوارش کمونی', 'ہاضمہ'],
    seoTitle: 'معدے کی تیزابیت اور گیس کا دیسی علاج | ہمالین پنسار سٹور',
    seoDescription: 'معدے کی جلن، تیزابیت اور گیس کا مستقل نباتاتی علاج۔ جوارش کمونی اور گھریلو قہوہ جات سے علاج بالغذا۔',
    seoKeywords: 'stomach gas cure, معدے کی تیزابیت, بدہضمی کا علاج, جوارش کمونی, پنسار ادویات',
    content: `
      <p class="lead text-lg font-medium text-gray-800 leading-relaxed mb-4">
        آج کل فاسٹ فوڈ، غیر معیاری کوکنگ آئل، رات دیر سے کھانا کھانے اور ذہنی تناؤ کی وجہ سے معدے کے امراض عام ہو چکے ہیں۔ ایلوپیتھک اینٹاسڈ اور پی پی آئی کیپسول عارضی سکون تو دیتے ہیں لیکن معدے کے قدرتی ہاضم مادوں کو سست کر دیتے ہیں۔
      </p>

      <h2 class="text-xl sm:text-2xl font-bold text-pansar-900 mt-6 mb-3 font-title">
        1. بیماری کی اصل جڑ کو سمجھیں
      </h2>
      <p class="text-gray-700 leading-relaxed mb-4">
        معدے میں تیزابیت کا بنیادی سبب صفراء یا بلغم کی زیادتی سے معدے کے منہ پر سوزش کا پیدا ہونا ہے۔ اس سے کھانا صحیح ہضم نہیں ہوتا، پیٹ میں سڑاند پیدا ہو کر گیس دماغ کی طرف چڑھتی ہے جسے طب میں <strong>تبخیرِ معدہ</strong> کہا جاتا ہے۔
      </p>

      <div class="my-5 p-4 rounded-2xl bg-emerald-50 border-r-4 border-emerald-600 text-emerald-950">
        <h4 class="font-bold text-emerald-900 mb-1 flex items-center gap-1.5 font-subheading">
          🍵 شفاء بخش قہوہ:
        </h4>
        <p class="text-sm leading-relaxed">
          سونف آدھا چمچ، سبز الائچی 2 عدد، اور پودینہ کی چند پتیاں ایک کپ پانی میں پکا کر کھانے کے بعد پئیں۔ یہ فوری طور پر گیس اور تیزابیت کو تحلیل کرتا ہے۔
        </p>
      </div>

      <h2 class="text-xl sm:text-2xl font-bold text-pansar-900 mt-6 mb-3 font-title">
        2. نباتاتی دوا: جوارش کمونی کبیر
      </h2>
      <p class="text-gray-700 leading-relaxed mb-3">
        جوارش کمونی معدے کے عضلات کو سمیٹ کر طاقت دیتی ہے، خوراک کو جلد ہضم کراتی ہے اور دائمی قبض کو رفع کرتی ہے۔
      </p>
    `,
    contentHtml: `
      <p class="lead text-lg font-medium text-gray-800 leading-relaxed mb-4">
        آج کل فاسٹ فوڈ، غیر معیاری کوکنگ آئل، رات دیر سے کھانا کھانے اور ذہنی تناؤ کی وجہ سے معدے کے امراض عام ہو چکے ہیں۔ ایلوپیتھک اینٹاسڈ اور پی پی آئی کیپسول عارضی سکون تو دیتے ہیں لیکن معدے کے قدرتی ہاضم مادوں کو سست کر دیتے ہیں۔
      </p>

      <h2 class="text-xl sm:text-2xl font-bold text-pansar-900 mt-6 mb-3 font-title">
        1. بیماری کی اصل جڑ کو سمجھیں
      </h2>
      <p class="text-gray-700 leading-relaxed mb-4">
        معدے میں تیزابیت کا بنیادی سبب صفراء یا بلغم کی زیادتی سے معدے کے منہ پر سوزش کا پیدا ہونا ہے۔ اس سے کھانا صحیح ہضم نہیں ہوتا، پیٹ میں سڑاند پیدا ہو کر گیس دماغ کی طرف چڑھتی ہے جسے طب میں <strong>تبخیرِ معدہ</strong> کہا جاتا ہے۔
      </p>

      <div class="my-5 p-4 rounded-2xl bg-emerald-50 border-r-4 border-emerald-600 text-emerald-950">
        <h4 class="font-bold text-emerald-900 mb-1 flex items-center gap-1.5 font-subheading">
          🍵 شفاء بخش قہوہ:
        </h4>
        <p class="text-sm leading-relaxed">
          سونف آدھا چمچ، سبز الائچی 2 عدد، اور پودینہ کی چند پتیاں ایک کپ پانی میں پکا کر کھانے کے بعد پئیں۔ یہ فوری طور پر گیس اور تیزابیت کو تحلیل کرتا ہے۔
        </p>
      </div>

      <h2 class="text-xl sm:text-2xl font-bold text-pansar-900 mt-6 mb-3 font-title">
        2. نباتاتی دوا: جوارش کمونی کبیر
      </h2>
      <p class="text-gray-700 leading-relaxed mb-3">
        جوارش کمونی معدے کے عضلات کو سمیٹ کر طاقت دیتی ہے، خوراک کو جلد ہضم کراتی ہے اور دائمی قبض کو رفع کرتی ہے۔
      </p>
    `
  },
  {
    id: 'blog-5',
    slug: 'pure-saffron-medicinal-wonders',
    title: 'خالص زعفران: مزاج، طبی اثرات اور مقویِ قلب و اعصاب خصوصیات',
    titleUrdu: 'خالص زعفران: مزاج، طبی اثرات اور مقویِ قلب و اعصاب خصوصیات',
    titleEn: 'Pure Saffron (Kesar): Medicinal Wonders, Dosage & Heart Vitality',
    category: 'herbs',
    categoryUrdu: 'جڑی بوٹیاں و نباتات',
    coverImage: 'https://images.unsplash.com/photo-1599940824399-b87987ceb72a?w=1200&auto=format&fit=crop&q=80',
    featuredImage: 'https://images.unsplash.com/photo-1599940824399-b87987ceb72a?w=1200&auto=format&fit=crop&q=80',
    author: 'حکیم مولانا سید عبدالوہاب شاہ شیرازی',
    authorTitle: 'فاضل طب والجراحت (FTJ) - ماہر قانون مفرد اعضاء',
    publishedDate: '2026-09-11',
    readTime: '5 منٹ',
    viewsCount: 570,
    status: 'published',
    linkedProductId: 'prod-3',
    excerpt: 'سرخ سونے کے نام سے مشہور زعفران کے طبی کرشمات۔ ڈپریشن، بے چینی، دل کی گھبراہٹ، چہرے کی رنگت نکھارنے اور اعصابی توانائی میں اس کے بے مثال اثرات۔',
    excerptUrdu: 'سرخ سونے کے نام سے مشہور زعفران کے طبی کرشمات۔ ڈپریشن، بے چینی، دل کی گھبراہٹ، چہرے کی رنگت نکھارنے اور اعصابی توانائی میں اس کے بے مثال اثرات۔',
    excerptEn: 'Detailed monograph on pure Saffron (Super Negin), its cardiac strengthening effects, mood enhancement, and anti-aging properties.',
    tags: ['زعفران', 'دل کی گھبراہٹ', 'ڈپریشن کا علاج', 'خالص زعفران', 'مقوی اعصاب'],
    seoTitle: 'خالص زعفران کے فوائد اور استعمال | ہمالین پنسار سٹور',
    seoDescription: 'خالص ایرانی زعفران کے طبی فوائد، مزاج، ڈپریشن اور امراض قلب میں طریقہ استعمال۔',
    seoKeywords: 'saffron benefits in urdu, زعفران کے فوائد, pure zafran, kesar uses, مقوی قلب',
    content: `
      <p class="lead text-lg font-medium text-gray-800 leading-relaxed mb-4">
        زعفران نباتاتی دنیا کا سب سے قیمتی پھول ہے۔ اس کے سرخ ریشوں (Stigmas) میں کروسین (Crocin) اور سیفرانل (Safranal) پائے جاتے ہیں جو انسانی دماغ میں خوشی کے ہارمونز کو بڑھاتے ہیں اور مایوسی و اداسی کو دور کرتے ہیں۔
      </p>

      <h2 class="text-xl sm:text-2xl font-bold text-pansar-900 mt-6 mb-3 font-title">
        1. زعفران کا طبی مزاج اور اثرات
      </h2>
      <p class="text-gray-700 leading-relaxed mb-3">
        زعفران کا مزاج <strong>گرم خشک درجہ اول (غدی عضلاتی)</strong> ہے۔ یہ دل اور روح کو فرحت بخشتا ہے، چہرے پر قدرتی سرخی اور رونق لاتا ہے اور شریانوں کے تناؤ کو کم کرتا ہے۔
      </p>

      <div class="my-5 p-4 rounded-2xl bg-amber-50 border-r-4 border-amber-600 text-amber-950">
        <h4 class="font-bold text-amber-900 mb-1 flex items-center gap-1.5 font-subheading">
          ✨ زعفرانی دودھ کی تیاری:
        </h4>
        <p class="text-sm leading-relaxed">
          زعفران کے 3 سے 5 ریشے ایک کپ گرم دودھ میں 10 منٹ بھگوئیں اور شہد ملا کر رات کو پئیں۔ یہ گہری پرسکون نیند اور اعصاب کی نئی زندگی کا ضامن ہے۔
        </p>
      </div>
    `,
    contentHtml: `
      <p class="lead text-lg font-medium text-gray-800 leading-relaxed mb-4">
        زعفران نباتاتی دنیا کا سب سے قیمتی پھول ہے۔ اس کے سرخ ریشوں (Stigmas) میں کروسین (Crocin) اور سیفرانل (Safranal) پائے جاتے ہیں جو انسانی دماغ میں خوشی کے ہارمونز کو بڑھاتے ہیں اور مایوسی و اداسی کو دور کرتے ہیں۔
      </p>

      <h2 class="text-xl sm:text-2xl font-bold text-pansar-900 mt-6 mb-3 font-title">
        1. زعفران کا طبی مزاج اور اثرات
      </h2>
      <p class="text-gray-700 leading-relaxed mb-3">
        زعفران کا مزاج <strong>گرم خشک درجہ اول (غدی عضلاتی)</strong> ہے۔ یہ دل اور روح کو فرحت بخشتا ہے، چہرے پر قدرتی سرخی اور رونق لاتا ہے اور شریانوں کے تناؤ کو کم کرتا ہے۔
      </p>

      <div class="my-5 p-4 rounded-2xl bg-amber-50 border-r-4 border-amber-600 text-amber-950">
        <h4 class="font-bold text-amber-900 mb-1 flex items-center gap-1.5 font-subheading">
          ✨ زعفرانی دودھ کی تیاری:
        </h4>
        <p class="text-sm leading-relaxed">
          زعفران کے 3 سے 5 ریشے ایک کپ گرم دودھ میں 10 منٹ بھگوئیں اور شہد ملا کر رات کو پئیں۔ یہ گہری پرسکون نیند اور اعصاب کی نئی زندگی کا ضامن ہے۔
        </p>
      </div>
    `
  },
  {
    id: 'blog-6',
    slug: 'pure-almond-oil-brain-and-skin',
    title: 'خالص روغنِ بادام شیریں: دماغی تیزی، نظر کی مضبوطی اور جلد کی حفاظت',
    titleUrdu: 'خالص روغنِ بادام شیریں: دماغی تیزی، نظر کی مضبوطی اور جلد کی حفاظت',
    titleEn: 'Pure Sweet Almond Oil: Brain Nourishment, Eyesight & Radiant Skin',
    category: 'oils',
    categoryUrdu: 'روغنیات و عرقیات',
    coverImage: 'https://images.unsplash.com/photo-1508746829417-e6f548d8d6ed?w=1200&auto=format&fit=crop&q=80',
    featuredImage: 'https://images.unsplash.com/photo-1508746829417-e6f548d8d6ed?w=1200&auto=format&fit=crop&q=80',
    author: 'حکیم مولانا سید عبدالوہاب شاہ شیرازی',
    authorTitle: 'فاضل طب والجراحت (FTJ) - ماہر قانون مفرد اعضاء',
    publishedDate: '2026-09-12',
    readTime: '5 منٹ',
    viewsCount: 310,
    status: 'published',
    linkedProductId: 'prod-5',
    excerpt: 'لکڑی کے کوہلو سے کشیدہ خالص روغنِ بادام شیریں کے فوائد۔ دماغی خشکی، نیند کی کمی، یادداشت کی کمزوری اور قبض کشائی کے لیے صدیوں کا آزمودہ نسخہ۔',
    excerptUrdu: 'لکڑی کے کوہلو سے کشیدہ خالص روغنِ بادام شیریں کے فوائد۔ دماغی خشکی، نیند کی کمی، یادداشت کی کمزوری اور قبض کشائی کے لیے صدیوں کا آزمودہ نسخہ۔',
    excerptEn: 'Clinical overview of cold-pressed Sweet Almond Oil for insomnia, dry brain, cognitive sharpness, and skin hydration.',
    tags: ['روغن بادام', 'دماغی کمزوری', 'نیند کی کمی', 'خالص روغن', 'خشکی کا علاج'],
    seoTitle: 'خالص روغنِ بادام شیریں کے فوائد | ہمالین پنسار سٹور',
    seoDescription: 'روغن بادام شیریں کے فوائد، دماغی خشکی اور نیند کی کمی کا علاج، پینے اور سر پر لگانے کا طریقہ۔',
    seoKeywords: 'almond oil benefits, روغن بادام شیریں, دماغی کمزوری, پنسار خالص تیل',
    content: `
      <p class="lead text-lg font-medium text-gray-800 leading-relaxed mb-4">
        بادام کا تیل وٹامن ای، میگنیشیم اور اومیگا 3 فیٹی ایسڈز سے بھرپور قدرتی ٹانک ہے۔ اگر یہ بغیر کسی کیمیکل یا ہیٹ کے کولڈ پریس (لکڑی کے کوہلو) کے ذریعے نکالا جائے تو اس کی غذائی و ادویاتی تاثیر سو فیصد برقرار رہتی ہے۔
      </p>

      <h2 class="text-xl sm:text-2xl font-bold text-pansar-900 mt-6 mb-3 font-title">
        1. دماغ اور اعصاب کے لیے استعمال
      </h2>
      <p class="text-gray-700 leading-relaxed mb-3">
        جو لوگ کمپیوٹر کا مسلسل کام کرتے ہیں، طلباء اور ذہنی دباؤ کے شکار افراد کے لیے رات کو ایک چمچ روغنِ بادام نیم گرم دودھ میں پینا دماغی رطوبت کو تر و تازہ رکھتا ہے اور سر درد سے نجات دلاتا ہے۔
      </p>
    `,
    contentHtml: `
      <p class="lead text-lg font-medium text-gray-800 leading-relaxed mb-4">
        بادام کا تیل وٹامن ای، میگنیشیم اور اومیگا 3 فیٹی ایسڈز سے بھرپور قدرتی ٹانک ہے۔ اگر یہ بغیر کسی کیمیکل یا ہیٹ کے کولڈ پریس (لکڑی کے کوہلو) کے ذریعے نکالا جائے تو اس کی غذائی و ادویاتی تاثیر سو فیصد برقرار رہتی ہے۔
      </p>

      <h2 class="text-xl sm:text-2xl font-bold text-pansar-900 mt-6 mb-3 font-title">
        1. دماغ اور اعصاب کے لیے استعمال
      </h2>
      <p class="text-gray-700 leading-relaxed mb-3">
        جو لوگ کمپیوٹر کا مسلسل کام کرتے ہیں، طلباء اور ذہنی دباؤ کے شکار افراد کے لیے رات کو ایک چمچ روغنِ بادام نیم گرم دودھ میں پینا دماغی رطوبت کو تر و تازہ رکھتا ہے اور سر درد سے نجات دلاتا ہے۔
      </p>
    `
  },
  {
    id: 'blog-7',
    slug: 'majun-falasfa-nerve-and-kidney-health',
    title: 'معجون فلاسفہ خاص: اعصابی تقویت، کمر درد اور گردوں کی کمزوری کا حل',
    titleUrdu: 'معجون فلاسفہ خاص: اعصابی تقویت، کمر درد اور گردوں کی کمزوری کا حل',
    titleEn: 'Majun Falasfa: Strengthening Nervous System, Backache & Renal Vitality',
    category: 'formulations',
    categoryUrdu: 'مرکبات و معجونات',
    coverImage: 'https://images.unsplash.com/photo-1509358271058-acd22cc93898?w=1200&auto=format&fit=crop&q=80',
    featuredImage: 'https://images.unsplash.com/photo-1509358271058-acd22cc93898?w=1200&auto=format&fit=crop&q=80',
    author: 'حکیم مولانا سید عبدالوہاب شاہ شیرازی',
    authorTitle: 'فاضل طب والجراحت (FTJ) - ماہر قانون مفرد اعضاء',
    publishedDate: '2026-09-12',
    readTime: '6 منٹ',
    viewsCount: 490,
    status: 'published',
    linkedProductId: 'prod-2',
    excerpt: 'حکماء و فلاسفہ کا مشہور تاریخی نسخہ۔ بار بار پیشاب آنا، جوڑوں اور پٹھوں کا کھچاؤ، مثانے کی کمزوری اور عام جسمانی نقاہت کا جامع علاج۔',
    excerptUrdu: 'حکماء و فلاسفہ کا مشہور تاریخی نسخہ۔ بار بار پیشاب آنا، جوڑوں اور پٹھوں کا کھچاؤ، مثانے کی کمزوری اور عام جسمانی نقاہت کا جامع علاج۔',
    excerptEn: 'Historical formulation Majun Falasfa, restoring kidney strength, relieving chronic lumbar pain, and strengthening the spinal nerves.',
    tags: ['معجون فلاسفہ', 'کمر درد', 'پٹھوں کا کھچاؤ', 'مثانے کی کمزوری', 'طب یونانی'],
    seoTitle: 'معجون فلاسفہ کے فوائد اور طریقہ استعمال | ہمالین پنسار سٹور',
    seoDescription: 'معجون فلاسفہ خاص کے فوائد، کمر درد، مثانے کی کمزوری اور اعصابی تقویت کے لیے مکمل معلومات۔',
    seoKeywords: 'majun falasfa benefits, معجون فلاسفہ, کمر کا درد, مقوی اعصاب معجون',
    content: `
      <p class="lead text-lg font-medium text-gray-800 leading-relaxed mb-4">
        معجون فلاسفہ یونانی و مشرقی طب کا وہ نایاب مرکب ہے جو صدیوں پہلے فلاسفہ اور اہل علم کے لیے ایجاد کیا گیا تاکہ ان کے دماغ، معدے اور اعصاب کو قوی رکھا جا سکے۔
      </p>

      <h2 class="text-xl sm:text-2xl font-bold text-pansar-900 mt-6 mb-3 font-title">
        1. اہم علامات جن میں مفید ہے
      </h2>
      <ul class="list-disc list-inside space-y-2 text-gray-700 leading-relaxed mb-4">
        <li>سردیوں میں یا رات کو بار بار پیشاب کی حاجت ہونا۔</li>
        <li>کمر اور پٹھوں میں دائمی کھچاؤ اور درد رہنا۔</li>
        <li>بھوک کی کمی اور کھانا دیر سے ہضم ہونا۔</li>
      </ul>
    `,
    contentHtml: `
      <p class="lead text-lg font-medium text-gray-800 leading-relaxed mb-4">
        معجون فلاسفہ یونانی و مشرقی طب کا وہ نایاب مرکب ہے جو صدیوں پہلے فلاسفہ اور اہل علم کے لیے ایجاد کیا گیا تاکہ ان کے دماغ، معدے اور اعصاب کو قوی رکھا جا سکے۔
      </p>

      <h2 class="text-xl sm:text-2xl font-bold text-pansar-900 mt-6 mb-3 font-title">
        1. اہم علامات جن میں مفید ہے
      </h2>
      <ul class="list-disc list-inside space-y-2 text-gray-700 leading-relaxed mb-4">
        <li>سردیوں میں یا رات کو بار بار پیشاب کی حاجت ہونا۔</li>
        <li>کمر اور پٹھوں میں دائمی کھچاؤ اور درد رہنا۔</li>
        <li>بھوک کی کمی اور کھانا دیر سے ہضم ہونا۔</li>
      </ul>
    `
  },
  {
    id: 'blog-8',
    slug: 'daily-diet-chart-tibb-e-pakistani',
    title: 'طبِ پاکستانی کی روشنی میں روزمرہ غذا کا متوازن انتخاب اور صحت کے اصول',
    titleUrdu: 'طبِ پاکستانی کی روشنی میں روزمرہ غذا کا متوازن انتخاب اور صحت کے اصول',
    titleEn: 'Daily Nutrition & Balanced Dietary Principles in Tibb-e-Pakistani',
    category: 'diet',
    categoryUrdu: 'غذائی علاج و پرہیز',
    coverImage: 'https://images.unsplash.com/photo-1490818387583-1baba5e638af?w=1200&auto=format&fit=crop&q=80',
    featuredImage: 'https://images.unsplash.com/photo-1490818387583-1baba5e638af?w=1200&auto=format&fit=crop&q=80',
    author: 'حکیم مولانا سید عبدالوہاب شاہ شیرازی',
    authorTitle: 'فاضل طب والجراحت (FTJ) - ماہر قانون مفرد اعضاء',
    publishedDate: '2026-09-12',
    readTime: '7 منٹ',
    viewsCount: 415,
    status: 'published',
    linkedProductId: 'prod-1',
    excerpt: 'بیماریوں سے بچاؤ اور لمبی صحت مند زندگی کے لیے روزمرہ خوراک کا درست انتخاب۔ ناشتہ، دوپہر اور رات کے کھانے میں مزاج کے مطابق توازن قائم رکھنے کا جامع چارٹ۔',
    excerptUrdu: 'بیماریوں سے بچاؤ اور لمبی صحت مند زندگی کے لیے روزمرہ خوراک کا درست انتخاب۔ ناشتہ، دوپہر اور رات کے کھانے میں مزاج کے مطابق توازن قائم رکھنے کا جامع چارٹ۔',
    excerptEn: 'Master dietary chart explaining how to align daily meals with biological temperaments to prevent chronic diseases.',
    tags: ['غذائی چارٹ', 'علاج بالغذا', 'صحت مند زندگی', 'پرہیز', 'صابر ملتانی'],
    seoTitle: 'روزمرہ غذا کا متوازن چارٹ اور اصول | طبِ پاکستانی',
    seoDescription: 'طب پاکستانی کے مطابق روزمرہ خوراک کا متوازن چارٹ، پرہیز اور بیماریوں سے بچاؤ کے آسان اصول۔',
    seoKeywords: 'diet chart in urdu, علاج بالغذا, غذائی پرہیز, طب پاکستانی خوراک',
    content: `
      <p class="lead text-lg font-medium text-gray-800 leading-relaxed mb-4">
        بقراط کا مشہور قول ہے کہ <em>"تمہاری غذا ہی تمہاری دوا ہونی چاہیے"</em>۔ اگر انسان روزمرہ خوراک میں مزاج کا خیال رکھے تو 90 فیصد امراض پیدا ہی نہیں ہوتے۔
      </p>

      <h2 class="text-xl sm:text-2xl font-bold text-pansar-900 mt-6 mb-3 font-title">
        1. غذائی توازن کا سنہری اصول
      </h2>
      <p class="text-gray-700 leading-relaxed mb-3">
        روزانہ ایک ہی قسم کی خوراک (جیسے صرف گوشت یا صرف چاول) کھانے سے جسم میں کسی ایک خلط کا غلبہ ہو جاتا ہے۔ غذا میں تازہ سبزیاں، اناج، دیسی گھی اور موسمی پھلوں کا تنوع لازمی رکھیں۔
      </p>
    `,
    contentHtml: `
      <p class="lead text-lg font-medium text-gray-800 leading-relaxed mb-4">
        بقراط کا مشہور قول ہے کہ <em>"تمہاری غذا ہی تمہاری دوا ہونی چاہیے"</em>۔ اگر انسان روزمرہ خوراک میں مزاج کا خیال رکھے تو 90 فیصد امراض پیدا ہی نہیں ہوتے۔
      </p>

      <h2 class="text-xl sm:text-2xl font-bold text-pansar-900 mt-6 mb-3 font-title">
        1. غذائی توازن کا سنہری اصول
      </h2>
      <p class="text-gray-700 leading-relaxed mb-3">
        روزانہ ایک ہی قسم کی خوراک (جیسے صرف گوشت یا صرف چاول) کھانے سے جسم میں کسی ایک خلط کا غلبہ ہو جاتا ہے۔ غذا میں تازہ سبزیاں، اناج، دیسی گھی اور موسمی پھلوں کا تنوع لازمی رکھیں۔
      </p>
    `
  }
];

export const BLOG_CATEGORIES = [
  { id: 'all', nameUrdu: 'تمام مضامین', nameEn: 'All Articles' },
  { id: 'herbs', nameUrdu: 'جڑی بوٹیاں و نباتات', nameEn: 'Herbal Medicine' },
  { id: 'theory', nameUrdu: 'قانون مفرد اعضاء', nameEn: 'Tibb Principles' },
  { id: 'vitality', nameUrdu: 'توانائی و مقویات', nameEn: 'Vitality & Energy' },
  { id: 'digestion', nameUrdu: 'نظامِ ہاضمہ و معدہ', nameEn: 'Digestive Health' },
  { id: 'oils', nameUrdu: 'روغنیات و عرقیات', nameEn: 'Oils & Extracts' },
  { id: 'formulations', nameUrdu: 'مرکبات و معجونات', nameEn: 'Formulations' },
  { id: 'diet', nameUrdu: 'غذائی علاج و پرہیز', nameEn: 'Diet & Nutrition' }
];
